export default "__VITE_ASSET__C92x3x3p__"